module.exports = __webpack_public_path__ + "src/assets/games/8/109.jpg";